<template>
	<div class="sticky-button-reserve-space">
		<section
			v-if="productIsNotInCart && orderable"
			class="sticky-button sticked hidden-desktop"
		>
			<div class="sticky-container">
				<div class="left">
					<div class="text">
						<TnParagraph
							bold
							size="s"
						>
							{{ price }}
						</TnParagraph>
					</div>
				</div>
				<ECommerceOrderButton
					size="xs"
					class="the-sticky-button"
				/>
			</div>
		</section>
	</div>
</template>

<script>
import ECommerceProductMixin from "../ECommerceProductMixin/ECommerceProductMixin.js";
import GizmoComponentMixin from "~/mixins/platform/GizmoComponentMixin.js";
import { formatPrice } from "~/helpers/formatting/price";
import { mapGetters, mapState } from "vuex";

export default defineNuxtComponent({
	name: "ECommerceAddToCartStickyButton",

	props: {
		component: {
			type: Object,
		},
	},

	mixins: [ECommerceProductMixin, GizmoComponentMixin],

	data() {
		return {
			stickToBottom: true,
			buttonOffset: 0,
			initialized: false,
		};
	},

	computed: {
		...mapGetters("shoppingCart", ["visibleCartItems"]),
		...mapGetters("ecommerce", ["downPaymentProducts"]),
		...mapState("ecommerce", ["selectedWebShopOption", "categoriesThatRequireStock"]),
		productIsNotInCart() {
			return this.eCommerceProduct.id !== this.visibleCartItems[0]?.data?.id;
		},
		price() {
			if (this.selectedWebShopOption.includes("DOWN_PAYMENT")) {
				const numberOfInstallments = parseInt(this.selectedWebShopOption?.slice(-2));
				const price = this.downPaymentProducts?.find((x) => x.monthlyInstallments === numberOfInstallments)?.prices
					.monthlyListPrice.value;

				return formatPrice.monthly(price, { ceil: true });
			} else if (this.eCommerceProduct.prices?.withVat?.fullPrice?.memberPrice) {
				return formatPrice.oneTime(this.eCommerceProduct.prices?.withVat?.fullPrice?.memberPrice, { round: true });
			}

			return formatPrice.oneTime(
				this.eCommerceProduct.prices?.withVat.fullPrice.salePrice ||
					this.eCommerceProduct.prices?.withVat?.fullPrice.price,
				{
					round: true,
				},
			);
		},
		inventory() {
			return this.eCommerceProduct?.inventory?.[0]?.amount || 0;
		},
		requiresStock() {
			return this.categoriesThatRequireStock.includes(this.eCommerceProduct?.category);
		},
		orderable() {
			return !(this.eCommerceProduct.unOrderable || (this.inventory <= 0 && this.requiresStock));
		},
	},
});
</script>

<style lang="scss" scoped>
.sticky-button-reserve-space {
	z-index: 2;
	display: inline-block;
}

.sticky-button {
	&.sticked {
		background: $color-primary-superlight;
		box-shadow:
			0 0 4px -2px rgb(0 0 0 / 12%),
			0 2px 8px 0 rgb(0 0 0 / 8%),
			0 4px 12px 0 rgb(0 0 0 / 4%);
		position: fixed;
		width: 100%;
		bottom: 0;
		left: 0;
		z-index: 1;
		margin-bottom: 0;
		padding: 0;
		padding-bottom: env(safe-area-inset-bottom, 0);
	}

	.sticky-container {
		display: flex;
		flex-wrap: nowrap;
		gap: $spacing-s;
		justify-content: space-between;
		align-items: center;
		max-width: 1190px; // todo: update this when design has decided
		margin: 0 auto;
		padding: $spacing-m 15px;
		position: relative;

		.left {
			display: flex;
			flex-wrap: nowrap;
			justify-content: flex-start;
			align-items: center;
			gap: $spacing-s;

			.close-button {
				flex-grow: 0;
				flex-shrink: 0;
				justify-self: flex-end;

				+ .text {
					@include breakpoint(mobile) {
						margin-right: 0;
					}
				}
			}
		}

		@include breakpoint(mobile) {
			padding: $spacing-s;
		}
	}
}

.button-container {
	display: flex;
	justify-content: space-between;
	align-items: center;

	@include breakpoint(mobile) {
		flex-direction: column;
		gap: $spacing-m;
		align-items: flex-start;
	}
}
</style>
